import React from 'react'
import { Grid, Typography, Divider } from '@material-ui/core'

import useStyles from './styles'

const SectionDivider = ({ title, color }) => {
  const { sdRoot, sdTitleContainer, sdTitle, sdDivider } = useStyles({ color })
  return (
    <Grid container className={sdRoot}>
      <Grid item xs className={sdTitleContainer}>
        <Typography className={sdTitle} noWrap>
          {title}
        </Typography>
      </Grid>
      <Grid item xs>
        <Divider className={sdDivider} />
      </Grid>
    </Grid>
  )
}

export default SectionDivider
